import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadablePrequalOfferStart = loadable(
  () => import('./PrequalOfferPushStart'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadablePrequalOfferStart;
